import { Button, ButtonProps, darken, styled } from '@mui/material'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { ReactNode } from 'react'

// TODO it should be clear for color of button on hover
const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.neutral900,

  height: '40px',
  borderRadius: '12px',
  backgroundColor: theme.palette.neutral200,
  boxShadow: 'none',

  '&:hover, &:active': {
    backgroundColor: darken(theme.palette.neutral200, 0.1),
    boxShadow: 'none',
  },
}))

// TODO check for additional prop (needs logic)
interface PropTypes extends ButtonProps {
  text: string | ReactNode
}

export function CancelButton({ text, ...props }: PropTypes) {
  const isDesktop = useIsDesktopSize()

  return (
    <StyledButton variant="contained" data-is-desktop={isDesktop} {...props}>
      {text}
    </StyledButton>
  )
}
